




























































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ApiHelper from 'api-helper';
import Toast from '@common/helpers/toast';
import PageLoader from '@components/common/PageLoader.vue';
import Pagination from '@components/common/Pagination.vue';
import LocalStorageUtils from '@common/LocalStorageUtils';
import lodash from 'lodash';

@Component({
  components: {
    Pagination,
    PageLoader,
  },
})
export default class PopupAddMenu extends Vue {

  get queryParams() {
    return {
      ...this.paginate,
      with: 'plan',
      menu_status: 1,
      clinic_ids: !this.isDefault ? this.clinic_ids.map((data) => data.id) : [],
      ...this.query,
      ...(this.isDefault ? { is_default: 1 } : { is_default: 0 }),
    };
  }
  get initialQuery() {
    return {
      ...this.paginate,
      with: 'plan',
      menu_status: 1,
      clinic_ids: !this.isDefault ? this.clinic_ids.map((data) => data.id) : [],
      ...(this.isDefault ? { is_default: 1 } : { is_default: 0 }),
    };
  }

  get isEmptyDataMenu(): boolean {
    return this.listMenus && !this.listMenus.length;
  }
  @Prop({ default: {} }) readonly menuSelected!: any;
  @Prop() readonly clinic_ids!: any;
  @Prop({ default: false }) readonly multiple!: boolean;
  @Prop({ default: false }) readonly isDefault!: boolean;
  @Prop(Boolean) readonly isShow!: boolean;
  paginate = {
    page: 1,
    per_page: 10,
    last_page: 1,
  };
  totalPage = 1;
  listMenus: any[] = [];
  scrollY = window.innerHeight - 100;
  planListTableEl: Element | null = null;
  private activeMenus: any[] = [];
  private isLoading: boolean = false;
  private query = {
    keyword: this.$route.query.keyword || '',
  };

  beforeOpen() {
    this.activeMenus = this.menuSelected || [];
    this.initDataDefault();
    this.getMenusList(this.initialQuery);
  }

  beforeClose() {
    this.paginate = {
      page: 1,
      per_page: 10,
      last_page: 1,
    };
    this.totalPage = 1;
    this.activeMenus = [];
  }

  initDataDefault() {
    // Clear data when close popup
    this.listMenus = [];
    this.paginate = {
      page: 1,
      per_page: 10,
      last_page: 1,
    };
    this.totalPage = 1;
    this.query = {
      keyword: '',
    };
  }

  cancelSetMenu() {
    this.activeMenus = [];
    this.initDataDefault();
    this.$emit('cancel');
  }

  getMenusList(query) {
    this.isLoading = true;

    if (this.paginate.page > this.paginate.last_page && this.paginate.last_page >= 1) {
      this.isLoading = false;
      return;
    }

    ApiHelper.getApi('MedicalMenuV2Api')
      .getList(query)
      .then((res: any) => {
        const lastPage = res ? res.meta.last_page : 1;
        if (this.paginate.page * this.paginate.per_page > this.listMenus.length + res.data.length - 1) {
          this.listMenus = [...this.listMenus, ...res.data];
        }

        this.paginate = {
          ...this.paginate,
          page: lastPage >= this.paginate.page ? this.paginate.page + 1 : this.paginate.page,
          last_page: lastPage,
        };
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  beforeDestroy() {
    this.planListTableEl?.removeEventListener('scroll', this.handleScroll);
  }

  private pageChanged(page) {
    let paramsSearch: any;
    this.paginate.page = page;

    paramsSearch = Object.assign({}, this.initialQuery);

    paramsSearch = {
      ...paramsSearch,
      ...this.paginate,
      page,
    };

    this.getMenusList(paramsSearch);
  }

  private isActiveMenu(menu) {
    return lodash.some(
      this.activeMenus,
      (data) => lodash.get(data, 'id') === menu.id,
    );
  }

  private handleSearch() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.paginate.page = 1;
    // LocalStorageUtils.saveItem('doctorDetailSearchMenu', JSON.stringify(this.queryParams));

    // ApiHelper.getApi('MenuApi').fetchMenuList(this.queryParams)
    ApiHelper.getApi('MedicalMenuV2Api')
      .getList(this.queryParams)
      .then((res: any) => {
        this.listMenus = res.data;
        this.totalPage = res.last_page;
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private closePopup() {
    this.$emit('closeModal');
  }

  private setActiveMenu(menu) {
    if (this.multiple) {
      const found = this.activeMenus.find((item: any) => item.id === menu.id);
      if (found) {
        this.activeMenus = this.activeMenus.filter((item: any) => item.id !== menu.id);
      } else {
        this.activeMenus = [...this.activeMenus, menu];
      }
    } else {
      this.activeMenus = [menu];
    }
  }

  private checkActiveMenu(item) {
    return this.activeMenus.some((act: any) => act.id === item.id);
  }

  @Watch('isShow')
  private isShowChanged() {
    setTimeout(() => {
        this.planListTableEl = document.querySelector('.table-common');
        this.planListTableEl?.addEventListener('scroll', this.handleScroll);
      }, 100);
  }

  private handleScroll(event: Event) {
    const container = event.target as HTMLElement;
    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollTop + clientHeight >= scrollHeight - 10 && !this.isLoading) {
      this.getMenusList(this.queryParams);
    }
  }

  private handleSubmit() {
    const data = this.multiple ? this.activeMenus : this.activeMenus[0] || null;
    this.$emit('submit', data);
    this.$emit('cancel');
  }
}
